
import DecreaseIndent from "../../../assets/duotone/DecreaseIndent.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DecreaseIndentIcon({ className, dataTestid = "DecreaseIndentIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DecreaseIndent data-testid={dataTestid} className={classes} {...rest} />
  );
}
